import { forwardRef } from "react";
import { Box, Button, CardContent, Divider, Grid2, Typography, useTheme } from "@mui/material";
import { Group } from "@mui/icons-material";
import { LocationAvailability } from "../../../features/Booking-Form/typings/booking-location";
import { ConnectedBookingData } from "../../../features/Booking-Form/typings/connected-bookingData";
import { useTranslation } from "react-i18next";

type P = {
  location: LocationAvailability;
  uniqConnectedBookingData: ConnectedBookingData[];
  setIsColleagueDataOpen: (o: boolean) => void;
};

export const LocationCardContent: React.FC<P> = forwardRef<HTMLDivElement, P>(
  ({ location, uniqConnectedBookingData, setIsColleagueDataOpen }, ref) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { name, address1, address2, postalCode, city } = location;

    return (
      <Box
        ref={ref}
        sx={{ display: "flex", flexDirection: "column", width: "100%" }}
        data-testid="location-card-content-parent"
      >
        <CardContent sx={{ flex: "0 0 auto", p: "16px 16px 0 16px" }}>
          <Grid2 container data-testid="location-card-content-locationName">
            {/* this grid item can be replaced by <ResizableTextComponent name={name} /> */}
            <Grid2>
              <Typography component="h5" variant="h5" sx={{ overflowWrap: "anywhere" }}>
                {name === "Mobile Working" ? t("Mobile Working") : name}
              </Typography>
            </Grid2>
          </Grid2>

          {name !== "Mobile Working" && (
            <>
              <Divider sx={{ borderColor: theme.palette.text.primary, opacity: "0.6" }} />
              <div style={{ marginTop: 5 }} data-testid="location-card-content-locationAddress">
                {city}, {postalCode}
                <Typography variant="subtitle1" color="textSecondary">
                  {address1} {address2}
                </Typography>
              </div>
            </>
          )}
        </CardContent>
        <Grid2
          container
          sx={{ alignItems: "center", pl: 2, pr: 1, justifyContent: "flex-end" }}
          data-testid="location-card-content-connectedBookingData-container"
        >
          <Grid2>
            {name !== "Mobile Working" && uniqConnectedBookingData && (
              <Button
                sx={{ borderWidth: "1.5px", "&:hover": { borderWidth: "1.5px" } }}
                disabled={!uniqConnectedBookingData.length}
                data-testid="show-connected-bookingData-btn"
                onClick={e => {
                  e.stopPropagation();
                  setIsColleagueDataOpen(true);
                }}
              >
                <Group />
                <Typography sx={{ pl: 0.5, fontWeight: "bold" }}>
                  {uniqConnectedBookingData.length}
                </Typography>
              </Button>
            )}
          </Grid2>
        </Grid2>
      </Box>
    );
  }
);
